module.exports = __webpack_public_path__ + "img/royalwomen.1ee3635.png";